export const Divider = {
  "border-color": "color",
  "border-style": "string",
  "border-width": "unit(px)",
  "container-background-color": "color",
  padding: "unit(px,%){1,4}",
  "padding-bottom": "unit(px,%)",
  "padding-left": "unit(px,%)",
  "padding-right": "unit(px,%)",
  "padding-top": "unit(px,%)",
  width: "unit(px,%)",
  align: "enum(left,center,right)",
};
